import { createHmac } from 'crypto'

export function sign (key, buffer, algo = 'sha512') {
  return createHmac(algo, key).update(buffer).digest('hex')
}

